import React from 'react';
import PropTypes, { func } from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Button } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '35px',
    display: 'flex',
    alignItems: 'center',
    marginTop: 0
  },
  spacer: {
    flexGrow: 1
  },
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  searchInput: {
    marginRight: theme.spacing(1)
  },
  buttons: {
    marginLeft: 15,
    marginBottom: 15
  }
}));

const EmpresaToolbar = props => {
  const { className, history, saveEmpresa, ...rest } = props;
  const [openDialogCancel, setOpenDialogCancel] = React.useState(false);

  const classes = useStyles();

  const cancelarInsercao = () => {
    history.goBack();
  };

  function abrirDialogCancel () {
    setOpenDialogCancel(!openDialogCancel);
  }

  return (

    <div
      {...rest}
      className={clsx(classes.root, className)}
    >

      <div className={classes.row}>
        <span className={classes.spacer} />

      </div>
      <div className={classes.row}>

        <span className={classes.spacer} />

        <Button
          color="primary"
          variant="contained"
          onClick={cancelarInsercao}
          className={classes.buttons}
        >
          Cancelar
        </Button>
        <Button
          color="primary"
          variant="contained"
          type={'submit'}
          className={classes.buttons}
        >
          Salvar
        </Button>
      </div>
    </div>
  );
};

EmpresaToolbar.propTypes = {
  className: PropTypes.string
};

export default EmpresaToolbar;
